module.exports = __webpack_public_path__ + "static/media/organisationDesktop.634a8f68.png";